export default "__VITE_ASSET__LKFxyKl0__"